import { render, staticRenderFns } from "./LandingPageHandPicked.vue?vue&type=template&id=0b3f5046"
import script from "./LandingPageHandPicked.vue?vue&type=script&lang=js"
export * from "./LandingPageHandPicked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports